import { useMediaQuery, Theme, Breakpoint } from "@mui/material";

/**
 * @param {Breakpoint} size - default value: sm
 */
export function useMobile(size: Breakpoint = "sm"): boolean {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down(size));
}
